export function post(url, data = {}) {
    if (data instanceof HTMLFormElement) data = Object.fromEntries(new FormData(data));
    data.csrf_token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.text())
        .then(text => {
            try {
                return JSON.parse(text);
            } catch (error) {
                return text;
            }
        })
}

Element.prototype.refreshDefaultValues = function (bubbles = false) {
    this.querySelectorAll('input').forEach(input => {
        input.setAttribute('value', input.value);
    })
}

Element.prototype.trigger = function (eventName, bubbles = true) {
    const event = new Event(eventName, {bubbles: bubbles});
    this.dispatchEvent(event);
}

Element.prototype.hasClass = function (className) {
    return this.classList.contains(className);
}

Element.prototype.addClass = function (className) {
    this.classList.add(className);
}

Element.prototype.removeClass = function (className) {
    this.classList.remove(className);
}

Element.prototype.toggleClass = function (className) {
    this.classList.toggle(className);
}

Element.prototype.fadeOut = async function (duration = 200) {
    const animation = this.animate(
        [{opacity: 1}, {opacity: 0}], {
            duration: duration, easing: 'ease-out', fill: 'forwards'
        }
    );

    await animation.finished;
    this.style.display = 'none';
    return this;
};


Element.prototype.fadeIn = async function (displayType = 'block', duration = 200) {
    this.style.display = displayType;

    const animation = this.animate(
        [{opacity: 0}, {opacity: 1}],
        {
            duration: duration, easing: 'ease-in', fill: 'forwards'
        }
    );

    await animation.finished;
    return this;
};